<template>
  <basic-card>
    <template slot="header">
      {{ displayName }}
    </template>
    <div v-if="contentHTML" v-html="contentHTML" style="padding-bottom: 0.25em;">

    </div>


    <framed-content title="Jobs">
      <div v-for="selectedDefinition in selectedDefinitions">
        <span :style="{ color: selectedDefinition.running ? '#ee7b06' : '#4ab24a' }">[{{ selectedDefinition.running ? `Running (${selectedDefinition.progress * 100}%)` : "Ready" }}]</span>
        {{ selectedDefinition.name }}

      </div>
    </framed-content>

    <div>
      <simple-button :disabled="isAnyRunning" @press="handleExecute">
        {{ contentButton }}
      </simple-button>
    </div>
  </basic-card>
</template>

<script>
import BasicCard from "@/components/layout/BasicCard";
import DataTable from "@/components/table/DataTable";
import {mapGetters} from "vuex";
import SimpleButton from "@/components/button/SimpleButton";
import FramedContent from "@/components/layout/FramedContent";
import Axios from "axios";

export default {
  name: "SimpleProcessHistoryWidget",
  components: {FramedContent, SimpleButton, DataTable, BasicCard},
  props: {
    displayName: String,
    guard: Number,
    contentHTML: String,
    contentButton: String,
    importDefinitionsToRun: Array
  },
  data: function () {
    return {}
  },
  methods: {
    handleExecute() {
      return Promise.all(this.selectedDefinitions.map(def => Axios.post("processing/api/v1/processes", {
        values: {},
        definitionId: def.id,
      }).then(res => {
        if (res.status === 201) {
          this.$notify({
            group: 'application',
            title: `Execution of script started`,
            text: `Execution of ${def.name} started`,
            type: "ok"
          })
        } else if (res.status === 409) {
          this.$notify({
            group: 'application',
            title: 'Execution failed',
            text: `Execution of ${def.name} failed`,
            type: "error"
          })
        }
      })));
    }
  },
  computed: {
    isAnyRunning() {
      return !!this.selectedDefinitions.find(def => def.running);
    },
    selectedDefinitions() {
      return this.importDefinitionsToRun.map(def => {
        let importDef = this.importDefinition(def);
        let runningProcess = this.runningImportProcesses.find(running => running.definitionId == importDef.id);
        return {
          id: importDef.id,
          name: importDef.displayName,
          running: !!runningProcess,
          progress: runningProcess?.progress,
          startTime: runningProcess?.startTime
        };
      })
    },
    ...mapGetters({
      importDefinition: 'importDefinitions/importDefinition',
      importDefinitions: 'importDefinitions/importDefinitions',
      'runningImportProcesses': 'importProcesses/getRunningProcesses',
      user: 'users/user'
    })
  }
}
</script>

<style scoped>

</style>